<template>
	<v-container>
		<v-row>
			<v-col cols="12">
				<v-card :loading="loading" flat>
					<v-card-title>
						{{
							view
								? "Visualizar Organograma"
								: id
								? "Editar Organograma"
								: "Cadastrar Organograma"
						}}
					</v-card-title>
					<v-col class="pl-10 pr-10 pb-5" cols="12" md="12">
						<v-row>
							<v-col cols="12" md="4">
								<v-select
									v-model="organizationchart.CODGRP"
									:items="groups"
									item-text="DESGRP"
									item-value="CODGRP"
									label="Grupo"
									class="required"
									clearable
									:loading="loadingGroup"
								></v-select>
							</v-col>
							<v-col cols="12" md="4">
								<v-select
									v-model="organizationchart.GERCOPARE"
									:items="corporateAreas"
									item-text="DESAREA"
									item-value="GERCOPARE"
									label="Área Corporativa"
									:loading="loadingCorporateArea"
									clearable
									@change="updateCorporateArea()"
								></v-select>
							</v-col>
							<v-col cols="12" md="4">
								<v-select
									v-model="organizationchart.CODEMP"
									:items="companies"
									item-text="DESEMP"
									item-value="CODEMP"
									label="Empresa"
									:disabled="disableCompany"
									:loading="loadingCompany"
									clearable
									@change="getUnits(true)"
								></v-select>
							</v-col>
							<v-col cols="12" md="4">
								<v-select
									v-model="organizationchart.CODUNI"
									:items="units"
									item-text="DESUNI"
									item-value="CODUNI"
									label="Unidade"
									:disabled="disableUnit"
									:loading="loadingUnit"
									clearable
									@change="getAreas(true)"
								></v-select>
							</v-col>
							<v-col cols="12" md="4">
								<v-select
									v-model="organizationchart.CODARE"
									:items="areas"
									item-text="DESARE"
									item-value="CODARE"
									label="Área"
									:disabled="disableArea"
									clearable
									:loading="loadingArea"
								></v-select>
							</v-col>
							<v-col cols="6" md="6">
								<v-text-field
									v-model="organizationchart.DESORG"
									label="Descrição"
									class="required"
								></v-text-field>
							</v-col>
							<v-col cols="6" md="6">
								<v-text-field
									v-model="organizationchart.NUMNVL"
									label="Quantidade de Níveis"
									class="required"
								></v-text-field>
							</v-col>
						</v-row>
						<v-row class="mt-5">
							<v-container>
								<v-btn
									color="primary"
									depressed
									tile
									class="mr-4"
									@click="save"
									:disabled="loading"
									v-show="!view"
									>Salvar</v-btn
								>
								<v-btn
									color="primary"
									text
									class="mr-4"
									@click="$router.push('/organization-chart/list')"
									:disabled="loading"
									>Voltar</v-btn
								>
							</v-container>
						</v-row>
					</v-col>
				</v-card>
			</v-col>
		</v-row>
		<template>
			<Dialog ref="confirm" />
		</template>
	</v-container>
</template>

<script>
import CompanyGroupService from "../../app/Services/CompanyGroupService";

import Dialog from '../misc/Dialog';
import OrganizationChartService from "../../app/Services/OrganizationChartService";
import CompanyService from "../../app/Services/CompanyService";
import AreaService from "../../app/Services/AreaService";
import CorporateAreaService from "../../app/Services/CorporateAreaService";
import UnitService from "../../app/Services/UnitService";
import UserService from "../../app/Services/UserService";
import axios from "../../config/service/standard";

const companyGroupService = CompanyGroupService.build();
const organizationChartService = OrganizationChartService.build();
const companyService = CompanyService.build();
const areaService = AreaService.build();
const corporateAreaService = CorporateAreaService.build();
const unitService = UnitService.build();
const userService = UserService.build();

export default {
	name: "ProgramForm",
	components: { Dialog },
	data: () => ({
		id: null,
		fileRules: [],
		view: false,
		groups: [],
		companies: [],
		areas: [],
		corporateAreas: [],
		units: [],
		status: [
			{ id: "A", description: "Aberto" },
			{ id: "F", description: "Fechado" }
		],
		organizationchart: {
			CODORG: 0,
			CODGRP: 0,
			CODEMP: 0,
			CODUNI: 0,
			CODARE: 0,
			GERCOPARE: 0,
			DESORG: "",
			NUMNVL: 1,
			CREATED_AT: "",
			UPDATED_AT: ""
		},
		loadingGroup: false,
		loading: false,
		loadingCompany: false,
		loadingUnit: false,
		loadingArea: false,
		loadingCorporateArea: false,
		disableCompany: false,
		disableUnit: false,
		disableArea: false,
		fileBase64: ""
	}),
	mounted() {
		const { id, view } = this.$route.params;

		if (id) {
			this.id = id;
		}

		if (view) {
			this.view = view;
		}

		this.fetch();
	},
	methods: {
		toast(type, message, icon = "mdi-check") {
			this.$toasted.show(message, {
				type: type,
				icon: icon
			});
		},
		save() {
			if (!this.organizationchart.CODGRP) {
				this.toast(
					"warning",
					"Informe o grupo para continuar"
				);
				return;
			}

			if (!this.organizationchart.DESORG) {
				this.toast(
					"warning",
					"Informe o descrição para continuar"
				);
				return;
			}

			if (!this.organizationchart.NUMNVL) {
				this.toast(
					"warning",
					"Informe a quantidade de níveis para continuar"
				);
				return;
			}

			if (this.organizationchart.NUMNVL < 1) {
				this.toast(
					"warning",
					"Informe a quantidade de níveis maior que 0 para continuar"
				);
				return;
			}

			this.loading = true;
			this.organizationchart.CODGRP = this.organizationchart.CODGRP || 0;
			this.organizationchart.CODEMP = this.organizationchart.CODEMP || 0;
			this.organizationchart.CODUNI = this.organizationchart.CODUNI || 0;
			this.organizationchart.CODARE = this.organizationchart.CODARE || 0;
			this.organizationchart.GERCOPARE = this.organizationchart.GERCOPARE || 0;

			const rest = this.id
				? organizationChartService.update({ id: this.id, ...this.organizationchart })
				: organizationChartService.create({ ...this.organizationchart });

			rest.then(response => {
				if (!response) {
					return;
				}

				this.toast(
					"success",
					this.id
						? "Organograma atualizada com sucesso!"
						: "Organograma adicionada com sucesso!"
				);
				this.loading = false;

				if (!this.isInModal) {
					this.$router.push("/organization-chart/list");
				} else {
					this.$emit("saved", true);
				}
			});
		},
		async getProcess() {
			this.loading = true;

			return organizationChartService.read({ id: this.id }).then(response => {
				this.organizationchart = response;
				this.loading = false;
			});
		},
		getGroup() {
			this.loadingGroup = true;

			companyGroupService.search('').then(response => {
				this.groups = response;
				this.loadingGroup = false;
			});
		},
		getCompanies() {
			this.loadingCompany = true;
			return companyService.search({}).then(response => {
				this.companies = response;
				this.loadingCompany = false;
			});
		},
		getUnits(change) {
			const search = {};

			this.units = [];
			this.areas = [];
			this.loadingUnit = true;

			if (change) {
				this.organizationchart.CODUNI = "";
				this.organizationchart.CODARE = "";
			}

			if (this.organizationchart.CODEMP) {
				search.company = this.organizationchart.CODEMP;
			}

			return unitService.search(search).then(response => {
				this.units = response;
				this.loadingUnit = false;
			});
		},
		getAreas(change) {
			const search = {};

			this.areas = [];
			this.loadingArea = true;

			if (change) {
				this.organizationchart.CODARE = "";
			}

			if (this.organizationchart.CODEMP) {
				search.company = this.organizationchart.CODEMP;
			}

			if (this.organizationchart.CODUNI) {
				search.unit = this.organizationchart.CODUNI;
			}

			areaService.search(search).then(response => {
				this.areas = response;
				this.loadingArea = false;
			});
		},
		getCorporateArea(change) {
			const search = {};

			this.corporateAreas = [];
			this.loadingCorporateArea = true;

			if (change) {
				this.organizationchart.CODARE = "";
			}

			if (this.organizationchart.CODEMP) {
				search.company = this.organizationchart.CODEMP;
			}

			if (this.organizationchart.CODUNI) {
				search.unit = this.organizationchart.CODUNI;
			}

			corporateAreaService.search(search).then(response => {
				this.corporateAreas = response;
				this.loadingCorporateArea = false;
			});
		},
		getUsers() {
			this.loadingUser = true;
			return userService.usersByKey().then(response => {
				this.users = response;
				this.loadingUser = false;
			});
		},
		updateCorporateArea() {
			if (parseInt(this.organizationchart.GERCOPARE) > 0) {
				this.organizationchart.CODEMP = 0;
				this.organizationchart.CODUNI = 0;
				this.organizationchart.CODARE = 0;

				this.disableCompany = true;
				this.disableUnit = true;
				this.disableArea = true;
			} else {
				this.disableCompany = false;
				this.disableUnit = false;
				this.disableArea = false;
			}
		},
		fetch() {
			const funcs = [];

			if (this.id) {
				funcs.push(this.getProcess());
			}

			funcs.push(this.getGroup());
			funcs.push(this.getCompanies());
			funcs.push(this.getUsers());
			funcs.push(this.getCorporateArea());

			Promise.all(funcs)
				.then(() => {
					if (this.id) {
						this.getUnits(false);
						this.getAreas();
						this.updateCorporateArea();
					}
				})
				.finally(() => {});
		},
		onFileSelect(fileTmp) {
			if (fileTmp == null) return;

			this.organizationchart.FILE_NAME = fileTmp.name;

			this.toBase64(fileTmp).then(base64 => {
				this.fileBase64 = base64;
			});
		},
		toBase64(file) {
			return new Promise((resolve, reject) => {
				const reader = new FileReader();
				reader.onload = () => resolve(reader.result);
				reader.onerror = error => reject(error);
				reader.readAsDataURL(file);
			});
		},
		download() {
			this.$root.$Loading.show("Fazendo download...");

			axios
				.get("/api/process/download", {
					responseType: "arraybuffer",
					params: {
						id: this.organizationchart.GERPRO
					}
				})
				.then(response => {
					let blob = new Blob([response.data], {
						type: "application/pdf"
					});
					let link = document.createElement("a");
					link.href = window.URL.createObjectURL(blob);
					link.download = this.organizationchart.TITPRO;
					link.click();
				})
				.finally(() => {
					this.$root.$Loading.hide();
				});
		},
		async removeDownload() {
			await this.$refs.confirm.open('Atenção', 'Deseja mesmo excluir?').then(() => {
				this.$root.$Loading.show("Removendo arquivo...");

				axios
					.post("/api/process/removeDownload", {
						id: this.organizationchart.GERPRO
					})
					.then(() => {
						this.toast("success", "Arquivo removido com sucesso!");
						this.organizationchart.FILE = null;
					})
					.finally(() => {
						this.$root.$Loading.hide();
					});
			});
		},
	}
};
</script>
